import { useAlertsStore } from '../components/alert/alerts.composable';
import { readableServerMessage } from './extract-error-message.util';

export function handleError(error: unknown): void {
  const alerts = useAlertsStore();
  const message = readableServerMessage(error);

  if (message) {
    alerts.error(message);
  } else {
    alerts.somethingWentWrong();
  }
}
